module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"continue":"Continue","cancel":"Cancel","confirm":"Confirm"}}')
  delete Component.options._Ctor
}
